export default {
    live: process.env.VUE_APP_LIVE,
    mobile: process.env.VUE_APP_MOBILE,
    user: process.env.VUE_APP_USER_DOMAIN,
    doc: process.env.VUE_APP_DOC_DOMAIN,
    med: process.env.VUE_APP_MED_DOMAIN,
    web: process.env.VUE_APP_WEB_DOMAIN,
}